import moment from 'moment';

export function formatMediumDate(isoString) {
    if (!isoString) return '';
    return moment.utc(isoString).format('MMM D, YYYY');
}
